export default __webpack_public_path__ + "static/media/user_icon_success.8f5bb4da.svg";